import {
  forwardRef,
  type InputHTMLAttributes,
  type TextareaHTMLAttributes,
} from "react";
import { cn } from "../lib/utils";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(({
  className,
  type,
  ...props
}, ref) => (
  <input
    className={cn("sqk-input", className)}
    ref={ref}
    type={type}
    {...props}
  />
));
Input.displayName = "Input";

export const SearchInput = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(({
  className,
  ...props
}, ref) => (
  <label className={cn("sqk-search-input", className)}>
    <span>Find</span>
    <Input ref={ref} type="search" {...props} />
  </label>
));
SearchInput.displayName = "SearchInput";

/** Multi-line text in the input's frame; grows vertically only. */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(({
  className,
  rows = 4,
  ...props
}, ref) => (
  <textarea
    className={cn("sqk-input sqk-textarea", className)}
    ref={ref}
    rows={rows}
    {...props}
  />
));
Textarea.displayName = "Textarea";
